import React from 'react';

import QuestionsAndAnswers from './data/q-and-a';
import FAQ from './FAQ';

const FAQS = () => (
  <div className="faqs-list">
    <h2 className="faqs-list__header" id="faqs">Answered Questions</h2>
    {QuestionsAndAnswers.map(obj => <FAQ faqItem={obj} key={obj.id} />)}
  </div>
);

export default FAQS;



// WEBPACK FOOTER //
// ./src/views/Home/components/FAQs/index.js